import axios from 'axios'

const webApi = process.env.VUE_APP_URL;

export default{
	loginWebApi(credentials){
		return axios.post(webApi + 'api/login', credentials);
	},
	logoutWebApi(){
		return axios.get(webApi + 'api/logout');
	}
}